export enum PanoramaTransactions {
  availabilityTimeSlotsSingleService = 'availability-time-slots-single-service',
  availabilityTimeSlotsClass = 'availability-time-slots-class',
  availabilityTimeSlotsMultiService = 'availability-time-slots-multi-service',
  calculateMultiSlotAvailability = 'calculate-multi-slot-availability',
  CalendarRegularBookFlow = 'calendar-regular-book-flow',
  calendarWidgetInitialization = 'calendar-widget-initialization',
  calendarServicesQuery = 'calendar-services-query',
  calendarSlotsFetch = 'calendar-slots-fetch',
  calendarRescheduleBooking = 'calendar-reschedule-booking',
  calendarBookingsSettingsFetch = 'calendar-bookings-settings-fetch',
  calendarNextAvailableDate = 'calendar-next-available-date',
}
